import { references } from "common/helpers/references";
import { BarChart } from "common/components/charts/bar";

import { TabBodyView } from "./tabBody";

const BAR_HEIGHT = 20;
const MIN_BAR_GAP = 1;

export const ChartBody = TabBodyView.extend({
    className: "chart-body",
    
    getChartHeight() {
        return this.getOption("widget").getAvailableHeight();
    },
    
    _getNumberOfBars() {
        const availableHeight = this.getChartHeight();
        
        return ((availableHeight - 50) / (BAR_HEIGHT + MIN_BAR_GAP)) | 0; // 50 is space between tabs and first bar, taken by bar yAxis
    },
    
    getTooltipFormatter() {
        const self = this; // Curry in a reference to instance
        let hasSpecialTooltipSettings = false;
        let template = (data) => `${data.value}`;
        let data;
        
        try {
            const tooltipSettings = this.getOption("widget").model.subtypeModel.get("doublePivot").tooltip;
            template = tooltipSettings.template;
            data = tooltipSettings.data;
            
            hasSpecialTooltipSettings = true;
        } catch {
            // Don't throw error
            hasSpecialTooltipSettings = false;
        }
        
        return function() {
            let dataFormatter;
            
            if (hasSpecialTooltipSettings) {
                dataFormatter = data({
                    value: this.value,
                    primaryPivotAlias: self.getOption("primaryPivotAlias"),
                    secondaryPivotKey: self.getOption("key")
                });
            } else {
                dataFormatter = {
                    value: references.toAlias(this.value, self.getOption("key"))
                };
            }
            
            const tooltip = template(dataFormatter);
            
            // `this` here is point values from highcharts
            return `<span class='pz-popover' role='button' data-html='true' data-toggle='popover' data-trigger='hover' data-placement='top' data-content='${tooltip}'>${this.value}</span>`;
        };
    },
    
    makeContentBody() {
        const numberOfBars = this._getNumberOfBars();
        const widget = this.getOption("widget");
        
        return new BarChart({
            collection: this.collection,
            processData: (collection) => (collection.first(numberOfBars) || []).map((b) => b.toJSON()),
            chartOptions: {
                chart: {
                    margin: null,
                    spacingTop: null,
                    spacingBottom: null,
                    spacingLeft: null,
                    spacingRight: null
                },
                xAxis: {
                    type: "category",
                    labels: {
                        enabled: true,
                        useHTML: true,
                        formatter: this.getTooltipFormatter()
                    }
                },
                yAxis: {
                    tickInterval: null,
                    minTickInterval: 1,
                    floor: 0,
                    max: null,
                    minRange: 1,
                    allowDecimals: false,
                    opposite: true
                },
                tooltip: {
                    headerFormat: "",
                    valueSuffix: "",
                    useHTML: true,
                    pointFormat: "<span style=\"font-size:10px\">{point.name}: {point.y}</span><br/>"
                },
                plotOptions: {
                    bar: {
                        pointWidth: BAR_HEIGHT,
                        dataLabels: {
                            formatter() {
                                return `<div style="font-size:8px">${this.y}</div>`;
                            }
                        }
                    },
                    series: {
                        cursor: "pointer",
                        point: {
                            events: {
                                click(event) {
                                    widget.drilldownToSecondPivot(event, this.name);
                                }
                            }
                        }
                    }
                }
            },
            series: [{
                object: true,
                sorted: true,
                name: "Reason code",
                type: "bar",
                pointFormat: {
                    name: this.getOption("key"),
                    y: this.getOption("dataGetter")
                },
                extend: {
                    color: "#FFDEA2"
                }
            }],
            height: this.getChartHeight()
        });
    }
});
